export default __webpack_public_path__ + "media/components/Header/Images/Kerning_bigger-a15b2f6b0017d12cc01f8f96e4a0fcce.svg";